import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    ExternalReceptacleLinkColumn,
    ExternalConsignmentLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'PRECON',
      columns: [
        new TextColumn('Sender', 'precon.sender'),
        new TextColumn('Receiver', 'precon.receiver'),
        new TextColumn('Sending mailbox', 'precon.sendingMailbox'),
        new TextColumn('Receiving mailbox', 'precon.receivingMailbox'),
      ],
    },
    {
      Header: 'Origin IMPC',
      columns: [
        new TextColumn('Operator', 'origin.operator'),
        new TextColumn('Code', 'origin.impc'),
      ],
    },
    {
      Header: 'Destination IMPC',
      columns: [
        new TextColumn('Operator', 'destination.operator'),
        new TextColumn('Code', 'destination.impc'),
      ],
    },
    {
      Header: '',
      columns: [
        new TextColumn('Mail category', 'mailCategory'),
        new TextColumn('Mail class', 'mailClass'),
      ],
    },
    {
      Header: 'Consignment',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('ID', 'consignment.id')),
        new DateTimeColumn('Completion date', 'consignment.completionDate'),
      ],
    },
    {
      Header: 'Receptacle',
      columns: [
        new ExternalReceptacleLinkColumn(new TextColumn('ID', 'receptacle.id').withWidth(275)),
        new TextColumn('ID in PREDES', 'receptacle.idInPredes'),
        new TextColumn('Core ID in PREDES', 'receptacle.coreIdInPredes'),
      ],
    },
  ];
};
